<script setup>
import { computed } from 'vue'
import { useRoute, useRouter } from 'vue-router'
import { useI18n } from 'vue-i18n'
import { useGarageStore } from '@/stores/garage.js'
import Quote from '@/views/my_garage/pages/quote.vue'

// I18n
const { t } = useI18n()

// Stores
const router = useRouter()
const route = useRoute()
const garageStore = useGarageStore()

// Variables
const currentSection = computed(() => {
  const quoteId = Number(route.params.id)
  const quote = garageStore.allQuotes.find(q => q.id === quoteId)
  
  if (quote?.status === 'completed' || quote?.status === 'cancelled') {
    return 'service_history'
  }
  return 'current_quotes'
})

const sectionTitle = computed(() => {
  return currentSection.value === 'service_history' 
    ? t('my_garage.your_service_history')
    : t('my_garage.your_current_quotes')
})

const currentQuote = computed(() => {
  const quoteId = Number(route.params.id)
  return garageStore.allQuotes.find(q => q.id === quoteId)
})

</script>

<template>
  <div>
    <div class="py-4 px-4 lg:px-8 xl:px-16">
      <!-- <div class="flex w-full justify-center mb-4 max-h-[90px]">
        <component is="script" async src="https://pagead2.googlesyndication.com/pagead/js/adsbygoogle.js?client=ca-pub-9802466654600169"
        crossorigin="anonymous"></component>
        <ins class="adsbygoogle"
     style="display:inline-block;width:728px;height:90px"
     data-ad-client="ca-pub-9802466654600169"
     data-ad-slot="3449281061"></ins>
        <component is="script">
            (adsbygoogle = window.adsbygoogle || []).push({});
        </component>

      </div> -->

      <div class="flex flex-row mb-4 flex-wrap gap-2 text-lg breadcrumb-list">
        <p class="font-regular breadcrumb whitespace-nowrap cursor-pointer hover:opacity-70" @click="router.push('/my_garage/service')">{{ t('my_garage.service') }}</p>
        <p>/</p>
        <p class="font-regular breadcrumb whitespace-nowrap cursor-pointer hover:opacity-70" @click="router.push('/my_garage/service')">{{ t('my_garage.quotes.your_quotes') }}</p>
        <p>/</p>
        <p class="font-regular breadcrumb whitespace-nowrap cursor-pointer hover:opacity-70" @click="router.push('/my_garage/service')">{{ sectionTitle }}</p>
        <p>/</p>
        <p class="font-regular breadcrumb active-breadcrumb whitespace-nowrap">{{ currentQuote?.service_title || 'Quote' }}</p>
      </div>

      <div class="tab-container">
        <quote></quote>
      </div>

    </div>
  </div>
</template>

<style lang="scss" scoped>
@import '@/assets/styles/views/my_garage/my_garage';
</style>
